import { createFileRoute } from "@tanstack/react-router";
import { DeptContentForm } from "@/components/dept-content/DeptContentForm";
import { DEPT_PUBLICATIONS } from "@/lib/deptContent";

export const Route = createFileRoute("/_app/departments/publications/new")({
  component: () => <DeptContentForm cfg={DEPT_PUBLICATIONS} />,
});
